import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const ELASTICSEARCH_API = environment.elasticSearchEndpoint;

@Injectable({
  providedIn: 'root'
})

export class ElasticSearchService {

  private elasticSearch_api = ELASTICSEARCH_API;
  private sponsorIndex = environment.esSponsorsIndex;
  private propertiesIndex = environment.esPropertiesIndex;

  constructor(private http: HttpClient) { }

  searchProperty(searchString: any, owner: any){

    const searchQuery = {
      "query": {
        "bool": {
            "must": [
                {"match": {"name" : searchString.toLowerCase()}},
                {"match": {"owner" : owner.toLowerCase()}},
            ]
        }
    }
    }

    let headers = this.createRequestHeader();    //SimpleReqHeader
    
    return this.http.post<any>(this.elasticSearch_api +"/"+ this.propertiesIndex + "/_search", searchQuery, { headers: headers });

    // return this.http.get<any>(this.elasticSearch_api +"/"+ this.propertiesIndex + "/_search?q=" + searchString, { headers: headers });
  }

  searchSponsor(searchString: any){
    const searchQuery = {
      "query": {
        "prefix": {
          "name": searchString.toLowerCase()
        }
      }
    }

    let headers = this.createRequestHeader();    //SimpleReqHeader
    return this.http.post<any>(this.elasticSearch_api +"/"+ this.sponsorIndex + "/_search", searchQuery, { headers: headers });
  }

  private createRequestHeader() {
    let headers = new HttpHeaders();

    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    return headers;
  }
}
